import React from 'react';
import CriticalPageErrorBoundary from '@/components/CriticalPageErrorBoundary';

/**
 * Aísla fallos de render por módulo del panel (Fase 14).
 * El layout del dashboard sigue visible si un chunk lazy falla.
 */
export default function ModuleErrorBoundary({ moduleKey, children }) {
  return (
    <CriticalPageErrorBoundary component={moduleKey ? `module:${moduleKey}` : 'ModuleErrorBoundary'}>
      {children}
    </CriticalPageErrorBoundary>
  );
}
